import { Skeleton } from "@mui/material";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

const PackageSkeleton: FC<Props> = () => {
  return (
    <div className={styles.card}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <Skeleton variant="text" sx={{ width: "70%", fontSize: "14px" }} />
          <Skeleton variant="text" sx={{ width: "30%", fontSize: "14px" }} />
        </div>
        <div className={styles.firstLine}>
          <Skeleton variant="text" sx={{ width: "40%", fontSize: "14px" }} />
          <div className={styles.icons}>
            <Skeleton variant="rounded" width={14} height={14} />
            <Skeleton variant="rounded" width={14} height={14} />
          </div>
        </div>
        <Skeleton variant="text" sx={{ width: "100%", fontSize: "14px" }} />
        <Skeleton variant="text" sx={{ width: "40%", fontSize: "14px" }} />
      </div>
    </div>
  );
};

export default PackageSkeleton;
